"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _jsxFileName = "/Users/newuser/Documents/GitHub/wordsby-components/src/components/flexible-content.js";

var FlexibleContent =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(FlexibleContent, _React$Component);

  function FlexibleContent() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FlexibleContent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        rows = _this$props.rows,
        components = _this$props.components,
        data = _this$props.data;

    if (!!rows && !!components) {
      return rows.map(function (_ref, index) {
        var typename = _ref.__typename,
            rowData = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["__typename"]);
        var type = typename.replace("WordPressAcf_", "");
        var Component = components[type];
        return !!Component ? _react.default.createElement(Component, (0, _extends2.default)({
          key: index
        }, rowData, data, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 11
          },
          __self: this
        })) : console.warn("No component found for " + type + " type");
      });
    } else {
      return null;
    }
  };

  return FlexibleContent;
}(_react.default.Component);

var _default = FlexibleContent;
exports.default = _default;